<mat-card class="center" style="padding-top: 14px;text-align: center;">
  <mat-card-subtitle style="display: inline;">
    <object data="assets/images/nepraunik_logo.svg" type="image/svg+xml" style="height: 52px;">
      <h2 class="logo">
        <span>Nepraunik &amp; Prammer</span>
      </h2>
    </object>
  </mat-card-subtitle>
  <div style="height: 10px;">
    <mat-divider style="border-color: #ccc;"></mat-divider>
  </div>
  <router-outlet></router-outlet>
</mat-card>


// WEBPACK FOOTER //
// ./src/app/_authentication/auth.component.html